import React, { useEffect, useState } from 'react';
import './AdBar.css';
import Marquee from 'react-fast-marquee';

interface RotatedBanner {
  banner: string;
  link: string;
}

const AdBar: React.FC = () => {
  const [banners, setBanners] = useState<RotatedBanner[]>([]);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchBanners = async () => {
      try {
        const res = await fetch(
          'https://coinsult.dev/wp-json/custom/v1/promoted-options/'
        );
        if (!res.ok) {
          throw new Error(`HTTP ${res.status}`);
        }
        const data = await res.json();
        // data.rotated_banners is an object with keys like item-0, item-1, …
        const rotated = data.rotated_banners || {};
        const list = Object.values(rotated) as RotatedBanner[];
        setBanners(list);
      } catch (err: any) {
        console.error('Failed to load banners', err);
        setError('Could not load ads.');
      }
    };

    fetchBanners();
  }, []);

  if (error) {
    return <div className="ads-horizontalmarq error">{error}</div>;
  }

  if (banners.length === 0) {
    // you could show a loader here instead
    return null;
  }

  return (
    <div className="ads-horizontalmarq">
      <Marquee pauseOnHover speed={40}>
        {banners.map((item, idx) => (
          <div key={idx} className="image-adsbox">
            <a href={item.link} target="_blank" rel="noopener noreferrer">
              <img src={item.banner} alt={`Ad banner ${idx + 1}`} />
              <div className="adnote">Ad</div>
            </a>
          </div>
        ))}
      </Marquee>
    </div>
  );
};

export default AdBar;
